module.exports = __webpack_public_path__ + "static/media/bg_3.90d496c5.png";